import { defaultAttendanceScoreFeatureFlag } from "@src/appV2/ClipboardScore/constants";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useClipboardScorePolicyLinks() {
  return useCbhFlag(CbhFeatureFlag.ATTENDANCE_SCORE_POLICY_LINKS, {
    defaultValue: {},
  });
}

export function useDisableSecondShiftBonus() {
  return useCbhFlag(CbhFeatureFlag.ATTENDANCE_SCORE_INFO, {
    defaultValue: defaultAttendanceScoreFeatureFlag,
  });
}

export function useClipboardScorePriorityAccessShiftsPerWeek() {
  return useCbhFlag(CbhFeatureFlag.CLIPBOARD_SCORE_PRIORITY_ACCESS_SHIFTS_PER_WEEK, {
    defaultValue: 0,
  });
}

export function useClipboardScoreLaunchDate() {
  return useCbhFlag(CbhFeatureFlag.CLIPBOARD_SCORE_LAUNCH_DATE, {
    defaultValue: "",
  });
}

export function useDynamicPenaltiesConfig() {
  return useCbhFlag(CbhFeatureFlag.DYNAMIC_PENALTIES_CONFIG, {
    defaultValue: {
      enabled: false,
    },
  });
}

export function useDiscardLatenessBooktimeThreshold() {
  const clipboardScoreLatenessThreshold = useCbhFlag(
    CbhFeatureFlag.DISCARD_LATENESS_BOOKTIME_THRESHOLD,
    { defaultValue: 4 }
  );

  return {
    discardLatenessBooktimeThresholdInHours: clipboardScoreLatenessThreshold,
  };
}

export function useTimelinessBonusRedesignConfig() {
  return useCbhFlag(CbhFeatureFlag.TIMELINESS_BONUS_REDESIGN_CONFIG, {
    defaultValue: { enabled: false },
  });
}
